<div class="circle-counter" [ngStyle]="{'width': size + 'px'}">
    <div class="circle-counter__inner">
        <svg class="circle-counter__svg -for-background" [attr.height]="totalSize" [attr.width]="totalSize">
            <circle class="circle-counter__circle -for-background" fill="transparent" [attr.r]="radius" [attr.cx]="cxcy"
                [attr.cy]="cxcy"
                [ngStyle]="{'strokeDasharray': circumference + ' ' + circumference, 'strokeDashoffset': progressFull, 'strokeWidth': thickness}" />
        </svg>

        <svg class="circle-counter__svg -for-counter" [attr.height]="totalSize" [attr.width]="totalSize">
            <circle class="circle-counter__circle -for-counter" fill="transparent" [attr.r]="radius" [attr.cx]="cxcy"
                [attr.cy]="cxcy"
                [ngStyle]="{'strokeDasharray': circumference + ' ' + circumference, 'strokeDashoffset': progress, 'strokeWidth': thickness}" />
        </svg>

        <div class="circle-counter__content">
            <ng-content></ng-content>
        </div>
    </div>


</div>